<template>
    <div class="mx-4 border-gray-325 bg-white shadow md:mx-0">
        <div class="mx-4 mb-2 pt-4 text-[16px] font-semibold text-gray-900">
            Past Results
        </div>

        <div class="my-4 px-4">
            <StudentTableFocusAreaSelector
                v-on:focus-area-selected="filterByFocusArea"
            />
        </div>
        <div class="mx-4 mb-4 text-[16px] text-gray-625">
            Showing
            <span class="hidden md:inline-block"
                >{{ visibleQuizzesCount }} of</span
            >
            {{ totalQuizzes }}
            past
            <span v-if="visibleQuizzes.length === 1">quiz</span>
            <span v-else>quizzes</span>
        </div>
        <div class="" v-if="visibleQuizzes">
            <!-- desktop view-->
            <div class="hidden md:block">
                <table class="w-full">
                    <thead
                        class="text-left text-[14px] font-semibold text-gray-625"
                    >
                        <tr>
                            <th class="p-2 pl-4">Date</th>
                            <th class="p-2">Type</th>
                            <th class="p-2">Results</th>
                            <th class="p-2">Score</th>
                            <th class="p-2 pl-4"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="quiz in visibleQuizzes">
                            <tr class="border-t border-gray-325 odd:bg-gray-50">
                                <td class="p-2 pl-4 text-[16px] font-semibold">
                                    {{
                                        dayjs(quiz.created_at)
                                            .utc(true)
                                            .tz($page.props.auth.user.timezone)
                                            .format(
                                                $page.props.date_formats
                                                    .short_nice
                                            )
                                    }}
                                </td>
                                <td class="p-2 text-[16px] text-gray-625">
                                    <span v-if="quiz.type === 'random'"
                                        >Random</span
                                    >
                                    <span v-if="quiz.type === 'focus_area'">
                                        <span v-if="quiz.focus_area?.title">
                                            <text-clamp
                                                autoResize
                                                :max-lines="2"
                                                :text="quiz.focus_area.title"
                                            ></text-clamp>
                                        </span>
                                        <span v-else>Focus Area</span>
                                    </span>
                                    <span v-if="quiz.type === 'targeted'"
                                        >Targeted</span
                                    >
                                    <span v-if="quiz.type === 'assessment'"
                                        >Assessment</span
                                    >
                                    <span v-if="quiz.type === 'missed'"
                                        >Previously Missed</span
                                    >
                                </td>
                                <td class="w-16 p-2 text-[16px]">
                                    <StudentScoreBox
                                        :percent-average="quiz.score"
                                    />
                                </td>
                                <td class="p-2 text-[16px]">
                                    <span class="text-gray-625">
                                        {{
                                            Math.round(
                                                quiz.meta.length * quiz.score
                                            )
                                        }}/{{ quiz.meta.length }}
                                    </span>
                                </td>
                                <td class="flex justify-end p-2 text-[16px]">
                                    <Link
                                        :href="
                                            route('student.quiz.results', {
                                                student_quiz: quiz.id,
                                            })
                                        "
                                        class="ml-4 inline-block rounded border border-primary-525 px-2 py-2 text-center text-[15px] text-primary-525 hover:cursor-pointer hover:bg-primary-525 hover:text-white"
                                    >
                                        Review&nbsp;Results
                                    </Link>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <!-- mobile view-->
            <div class="bg-gray-125 md:hidden">
                <div class="flex flex-col gap-0">
                    <div
                        class="flex flex-col gap-4 border-t border-gray-325 bg-white p-3"
                        v-for="quiz in visibleQuizzes"
                    >
                        <div class="flex flex-row justify-between gap-4">
                            <div class="flex flex-col gap-0">
                                <div class="text-[16px] text-gray-625">
                                    {{
                                        dayjs(quiz.created_at)
                                            .utc(true)
                                            .tz($page.props.auth.user.timezone)
                                            .format(
                                                $page.props.date_formats
                                                    .short_nice
                                            )
                                    }}
                                </div>
                                <div
                                    class="flex flex-col gap-2 text-[16px] font-semibold text-gray-825"
                                >
                                    <span v-if="quiz.type === 'random'"
                                        >Random</span
                                    >
                                    <span v-if="quiz.type === 'focus_area'">
                                        <span v-if="quiz.focus_area?.title">
                                            <text-clamp
                                                autoResize
                                                :max-lines="2"
                                                :text="quiz.focus_area.title"
                                            ></text-clamp>
                                        </span>
                                        <span v-else>Focus Area</span>
                                    </span>
                                    <span v-if="quiz.type === 'targeted'"
                                        >Targeted</span
                                    >
                                    <span v-if="quiz.type === 'assessment'"
                                        >Assessment</span
                                    >
                                    <span v-if="quiz.type === 'missed'"
                                        >Previously Missed</span
                                    >
                                </div>
                            </div>
                            <div class="">
                                <StudentScoreBox
                                    :percent-average="quiz.score"
                                />
                            </div>
                        </div>
                        <div class="">
                            <Link
                                :href="
                                    route('student.quiz.results', {
                                        student_quiz: quiz.id,
                                    })
                                "
                                class="block rounded border border-primary-525 px-2 py-2 text-center text-[15px] text-primary-525 hover:cursor-pointer hover:bg-primary-525 hover:text-white"
                            >
                                Review&nbsp;Results
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <ModelPaginator
                ref="pastQuizPaginator"
                :endpoint="route('student.quizzes.fetch')"
                :limit="10"
                :params="filterParams"
                v-on:modelsFetched="updateVisibleQuizzes"
            >
            </ModelPaginator>
        </div>
    </div>
</template>
<script>
import StudentTableFocusAreaSelector from "@/Components/StudentTableFocusAreaSelector.vue";
import StudentScoreBox from "@/Components/StudentScoreBox.vue";
import ModelPaginator from "@/Components/ModelPaginator.vue";

export default {
    name: "StudentQuizzesPastQuizzesTable",
    components: {
        ModelPaginator,
        StudentScoreBox,
        StudentTableFocusAreaSelector,
    },

    data() {
        return {
            visibleQuizzes: [],
            totalQuizzes: 0,
            visibleQuizzesCount: 0,
            selectedFocusAreaId: null,
            filterParams: [],
        };
    },
    methods: {
        updateVisibleQuizzes(paginatorData) {
            this.totalQuizzes = paginatorData.totalResults;
            this.visibleQuizzesCount = paginatorData.results;
            this.visibleQuizzes = paginatorData.items;
        },
        filterByFocusArea(focusAreaId) {
            this.selectedFocusAreaId = focusAreaId;

            if (this.selectedFocusAreaId) {
                this.filterParams = [
                    "meta->focus_area_id,=," + this.selectedFocusAreaId,
                ];
            } else {
                this.filterParams = [];
            }
        },
    },
};
</script>
